import { createSelector } from "@ngrx/store";
import { accessToken, loggedIn, profileLoaded, profile, pending, AuthState } from "../reducers/auth.reducer";

const getAuthState = (state) => state.auth as AuthState;

export const getAccessToken = createSelector(getAuthState, accessToken);
export const getLoggedIn = createSelector(getAuthState, loggedIn);
export const getProfileLoaded = createSelector(getAuthState, profileLoaded);
export const getProfile = createSelector(getAuthState, profile);
export const getPending = createSelector(getAuthState, pending);

